<template>
  <div class="business">
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => (toast = val)"
    />

    <div>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <p class="title-income">Income</p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-normal-left">Gross Salary/Toal Earning:</p>
          </div>
          <div class="col-4">
            <p class="title-income-normal-right">
              <strong
                >₹
                {{
                  tdsBreakupList[tdsBreakupList.length - 1].totalEarning
                }}</strong
              >
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-normal-left">
              Income/Loss From Housing Property:
            </p>
          </div>
          <div class="col-4">
            <p class="title-income-normal-right">
              <strong
                >₹
                {{
                  tdsBreakupList[tdsBreakupList.length - 1].section24Deduction
                    .LossOnHouseProperty
                }}</strong
              >
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-normal-left">Other Income:</p>
          </div>
          <div class="col-4">
            <p class="title-income-normal-right">
              <strong
                >₹
                {{
                  tdsBreakupList[tdsBreakupList.length - 1].totalOtherIncome
                }}</strong
              >
            </p>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="col-12">
            <p class="title-income">Deductions</p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-normal-left">Exemption Under section 10:</p>
          </div>
          <div class="col-4">
            <p class="title-income-normal-right">
              <strong
                >₹
                {{
                  tdsBreakupList[tdsBreakupList.length - 1]
                    .totalSectionTenExemption
                }}</strong
              >
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-normal-left">Exemption Under section 16:</p>
          </div>
          <div class="col-4">
            <p class="title-income-normal-right">
              <strong
                >₹
                {{
                  tdsBreakupList[tdsBreakupList.length - 1]
                    .totalSectionSeventeenExemption
                }}</strong
              >
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-normal-left">
              Deduction Under Chapter VI A:
            </p>
          </div>
          <div class="col-4">
            <p class="title-income-normal-right">
              <strong
                >₹
                {{
                  tdsBreakupList[tdsBreakupList.length - 1]
                    .totalSectionSixADeduction
                }}</strong
              >
            </p>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="col-8">
            <p class="title-income-left">Total Taxable Income:</p>
          </div>
          <div class="col-4">
            <p class="title-income-right">
              ₹ {{ tdsBreakupList[tdsBreakupList.length - 1].taxableIncome}}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-left">Total Annual Tax:</p>
          </div>
          <div class="col-4">
            <p class="title-income-right">
              ₹
              {{ tdsBreakupList[tdsBreakupList.length - 1].totalTaxProjected }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-left">Tax Paid Till Date:</p>
          </div>
          <div class="col-4">
            <p class="title-income-right">
              ₹ {{ tdsBreakupList[tdsBreakupList.length - 1].tdsPaidTillLast }}
            </p>
          </div>
        </div>
      </div>
      <!-- <pop-up-message
        v-if="showSuccessMsg"
        :message="`Components successfully added`"
        btnText="Back To Assign Fixed Non CTC Components "
        @back="close"
      ></pop-up-message> -->

      <footer>
        <popup-bottom-container>
          <template slot="end">
            <btn-grp class="form-button">
              <!-- <btn text="Download" type="primary"/> -->
              <btn text="Back" type="secondary" @click="goBack" />
            </btn-grp>
          </template>
        </popup-bottom-container>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "itDeclarationStatmentOldRegimePopup",
  props: {
    tds_breakup_and_taxable_income: {
      type: Array,
    },
    itSheet: {
      type: Array,
    },
  },
  data() {
    return {
      errmsg: "",
      toast: false,
      showSuccessMsg: false,
      tdsBreakupTaxableIncome: [],
      tdsBreakupList: [],
    };
  },
  computed: {},

  mounted() {
    this.showSuccessMsg = false;
    this.load();
  },

  activated() {
    this.toast = false;
    this.errmsg = "";
    this.showSuccessMsg = false;
  },

  methods: {
    load() {
      this.tdsBreakupTaxableIncome = this.tds_breakup_and_taxable_income;
      ////console.log("Tds Data", this.tdsBreakupTaxableIncome);

      this.tdsBreakupList = this.itSheet;
      //console.log("Tda Data List", this.tdsBreakupList);
    },

    // Add here code for cancel button to hide popup By Bhushan
    goBack() {
      this.$emit("back");
    },
  },
};
</script>

<style lang="scss" scoped>
// .business {
//   width: 100%;
//   height: 100%;
// }

// .business .top-bar {
//   height: auto;
//   padding: 20px;
//   background-color: #34c0be;
//   display: flex;
// }

.title-income {
  font-size: 1.1rem;
  font-weight: 600;
  color: #444444;
}

.title-income-normal-left {
  font-size: 1rem;
  color: #444444;
}

.title-income-normal-right {
  font-size: 1rem;
  color: #444444;
  text-align: right;
}

.title-income-left {
  font-size: 1.1rem;
  font-weight: 600;
  color: #444444;
}

.title-income-right {
  font-size: 1.1rem;
  font-weight: 600;
  color: #444444;
  text-align: right;
}
</style>
